export const getToFixedValue = (value: number, depth = 2): number => +value.toFixed(depth);
